<template>
  <el-menu class="navbar">
    <div class="toplogo"><img :src="require('assets/images/top_logo.png')"></div>
    <!--<hamburger class="hamburger-container" :toggleClick="toggleSideBar" :isActive="sidebar.opened"></hamburger>-->

    <!--<breadcrumb class="breadcrumb-container"></breadcrumb>-->

    <div class="right-menu">
      <div class="right-nav-item">
        <el-menu :default-active="activeIndex"
                 mode="horizontal"
                 text-color="#666666"
                 active-text-color="#148cdc"
                 @select="handleSelect"
        >
          <!--<el-menu-item index="0"><router-link to="/home" >首页</router-link></el-menu-item>
          <el-menu-item index="2"><router-link to="/customer">用户系统</router-link></el-menu-item>
          <el-menu-item index="3"><router-link to="/contents">内容系统</router-link></el-menu-item>
          <el-menu-item index="4"><router-link to="/advertising">广告系统</router-link></el-menu-item>
          <el-menu-item index="5"><router-link to="/financial">支付系统</router-link></el-menu-item>
          <el-menu-item index="6"><router-link to="/education">教育系统</router-link></el-menu-item>-->
          <!--<el-menu-item index="1"><router-link to="/admin">系统管理</router-link></el-menu-item>-->
          <template>
            <el-menu-item v-if="item.name" v-for="(item,index) in navList" :key="index" :index="index+''"><router-link  :to="{ path: item.path }">{{item.name}}</router-link></el-menu-item>
          </template>
        </el-menu>
      </div>
      <error-log class="errLog-container right-menu-item"></error-log>

      <!--<el-tooltip effect="dark" content="全屏" placement="bottom">
        <screenfull class="screenfull right-menu-item"></screenfull>
      </el-tooltip>-->

      <!--<el-tooltip effect="dark" content="换肤" placement="bottom">
        <theme-picker class="theme-switch right-menu-item"></theme-picker>
      </el-tooltip>-->
      <div class="admin-user-container">
        <div class="user-avatar fl">
          <div class="avatar"></div>
          <div class="uName">{{userLogin.name}}</div>
          <!--<div>{{userLogin.role}}</div>-->
          <div class="btn-edit-psw" style="cursor: pointer; margin-top: 5px" @click="showEditPsw">修改密码</div>
        </div>
        <div class="fl outlogin" @click="logout"></div>
      </div>

      <!--<el-dropdown class="avatar-container right-menu-item" trigger="click">
        <div class="avatar-wrapper">
          <img class="user-avatar" :src="avatar+'?imageView2/1/w/80/h/80'">
          <i class="el-icon-caret-bottom"></i>
        </div>
        <el-dropdown-menu slot="dropdown">
          <router-link to="/">
            <el-dropdown-item>
              首页
            </el-dropdown-item>
          </router-link>
          <el-dropdown-item divided>
            <span @click="logout" style="display:block;">退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>-->
    </div>

    <editAdminPassword ref="editpassword"></editAdminPassword>

  </el-menu>
</template>

<script type="text/ecmascript-6">
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import ErrorLog from '@/components/ErrorLog'
import Screenfull from '@/components/Screenfull'
import ThemePicker from '@/components/ThemePicker'
import editAdminPassword from '@/components/editAdminPassword'
import { fetchUpdatePassword } from '@/api/Users/admin'

export default {
  components: {
    Breadcrumb,
    Hamburger,
    ErrorLog,
    Screenfull,
    ThemePicker,
    editAdminPassword
  },
  data() {
    return {
      activeIndex:'0',
      navList:[],
      userLogin:this.$store.getters.login,
      navRoot:['home','admin','customer','contents','advertising','financial','education'],
    }
  },
  computed: {
    ...mapGetters([
      'permission_routers',
      'sidebar',
    ])
  },
  created(){
    let navList=[],navRoot=[];
    for(let route of this.permission_routers){
      if(route.hidden) continue
      let rd={
        name:route.meta.title,
        path:route.path
      }
      if (route.children && route.children.length) {
        rd.path=`${route.path}/${route.children[0].path}`
      }
      navList.push(rd);
      navRoot.push(route.name);
    }
    this.navList=navList
    this.navRoot=navRoot;

    let root=this.$route.meta.root;
    const index=this.navRoot.indexOf(root);
    console.log(root,navRoot,index)
    this.activeIndex=index.toString();
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('toggleSideBar')
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload()// 为了重新实例化VUE路由器对象以避免bug
      })
    },
    handleSelect(key, keyPath) {
      //console.log(key, keyPath);
    },
    showEditPsw(){
      this.$refs.editpassword.setDialogStatus(true)
    },
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  position: relative;
  height: 80px;
  line-height: 80px;
  background-color: #ffffff;
  border-radius: 0px !important;
  overflow: hidden;
  .toplogo{
    float: left;
    height: 80px;
    overflow: hidden;
  }
  .hamburger-container {
    margin-top: 55px;
    margin-left: -130px;
    line-height: 30px;
    height: 20px;
    float: left;
    padding: 0 10px;
    color: #05aaf0;
  }
  .breadcrumb-container{
    float: left;
  }
  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }
  .right-menu {
    float: right;
    height: 100%;
    &:focus{
     outline: none;
    }
    .right-nav-item{
      float: left;
      display: inline-block;
      border: 0 !important;
      .el-menu-item{
        padding: 0;
        height: 80px;
        line-height: 80px;
        border-bottom: 0;
        font-size: 15px;
        font-weight: bold;
        a{
          display: inline-block;
          padding: 0 26px;
          height: 80px;
          line-height: 80px;
        }
        &.is-active{
          background: #f2f2f2;
         }
      }
    }
    .right-menu-item,{
      display: inline-block;
      margin: 0 8px;
    }
    .screenfull {
      height: 20px;
    }
    .international{
      vertical-align: top;
    }
    .theme-switch {
      vertical-align: 15px;
    }
    .admin-user-container{
      float: left;
      display: inline-block;
      padding-left: 12px;
      height: 80px;
      border-left:2px solid #f2f2f2;
      color: #148cdc;
      .user-avatar{
        display: inline-block;
        position: relative;
        padding-left: 42px;
        padding-right: 30px;
        padding-top: 22px;
        line-height: 18px;
        font-size: 12px;
      }
      .avatar{
        position: absolute;
        left: 0;
        top: 24px;
        width: 32px;
        height: 32px;
        border: #05AAF0 2px solid;
        border-radius: 50%;
        background: url(~@/assets/images/tAvatar.png) center no-repeat;
      }
      .uName{
        padding-top: 2px;
        font-size: 14px;
        font-weight: bold;
        color: #666666;
      }
      .outlogin{
        width: 50px;
        height: 80px;
        background-color: #F2F2F2;
        background-image: url('~@/assets/images/top_exit.png');
        background-position: center center;
        background-repeat: no-repeat;
      }
    }
    .avatar-container {
      height: 50px;
      margin-right: 30px;
      .avatar-wrapper {
        cursor: pointer;
        margin-top: 5px;
        position: relative;
        .user-avatar {
          width: 40px;
          height: 40px;
          border-radius: 10px;
        }
        .el-icon-caret-bottom {
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}

@media screen and (max-width: 1350px) {
  .navbar .right-menu{ position: absolute;right: 0;top:0; z-index: 999;}
  .navbar .right-menu .right-nav-item .el-menu-item a {
    padding: 0 18px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue